import { Component, OnInit } from '@angular/core';
import { AbstractComponent } from '../util/abstract.component';
import { SessaoService } from '../services/sessao.service';
import { CopiaContratoService } from '../services/copiacontrato.service';
import { MensagemService } from '../services/mensagem.service';
import { RestClientService } from '../services/restclient.service';
import { EnderecoContrato } from '../modelo/enderecoContrato';
import { MatDialog } from '@angular/material';
import { Config } from '../services/config';
import { CopiaContratoModalDisponivelComponent } from './copia-contrato-modal-disponivel.component';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { BraAlertComponent } from '../componentes/bra-alert/bra-alert.component';
import { CopiaContrato } from '../modelo/copiaContrato';
import { AreaCentralRelacionamento } from '../enumaration/area-central-relacionamento';
import { Router } from '@angular/router';
import { CopiaContratoModalAvisoCentralComponent } from './copia-contrato-modal-aviso-central.component';
import { CopiaContratoModalIndisponivelComponent } from './copia-contrato-modal-indisponivel.component';
import { CopiaContratoModalSistemaIndisponivelComponent } from './copia-contrato-modal-aviso-sistema-indisponivel.component';
import { CopiaContratoNewSpaceOrquestradora } from '../modelo/copiaContratoNewSpaceOrquestradora';

declare let $: any;

@Component({
  selector: 'app-copia-contrato-selecao',
  templateUrl: './copia-contrato-selecao.component.html',
  styleUrls: ['./copia-contrato.component.css'],
  providers: [CopiaContratoService, MensagemService, RestClientService]
})
export class CopiaContratoSelecaoComponent extends AbstractComponent implements OnInit {
  mensagemErro: string;
  contratoList: CopiaContrato[];
  msgTimeOut: string;

  constructor(
    private sessaoService: SessaoService,
    private copiaContratoService: CopiaContratoService,
    private mensagemService: MensagemService,
    private router: Router,
    private spinnerService: Ng4LoadingSpinnerService,
    public dialog: MatDialog
  ) {
    super(sessaoService);
  }

  /**
   * Método chamado na inicialização do componente
   */
  ngOnInit() {
    // Menu
    $('.btsMenu .btn').removeClass('active activeDrop');
    $('.copia').addClass('active');
    setTimeout(function(){
      $('ul.tabs').tabs();
    }, 600);

    // Bts modal
    $(function() {
      $('.disponivel').click(function(){
        $('#m-copia-disponivel').modal('open');
      });
      $('.pendente').click(function(){
        $('#m-copia-pendente').modal('open');
      });
    });

    // Carrega as áreas da central de relacionamento
    this.msgTimeOut = this.sessaoService.sessao.configuracaoVisual.listaCentralRelacionamento
      .filter(w => w.area.toString() == AreaCentralRelacionamento[AreaCentralRelacionamento.AREA_ESQUERDA])
      .sort((w1, w2): number => w1.nuLinha < w2.nuLinha ? -1 : w1.nuLinha > w2.nuLinha ? 1 : 0)
      .map(w => w.dsCentralRelacionamento)
      .join('');

    // Scroll top
    window.scrollTo(0, 0);

    this.buscaContratos();

    // Close Menu Mobile
    const isMobile = window.matchMedia('only screen and (max-width: 760px)');
    $('.content').click(function() {
      if (isMobile.matches) {
        $('.page').removeClass('toggled');
      }
    });

    const popup = document.getElementById('popUp');
    // Checa se o popup já foi fechado nesta sessão
    if (sessionStorage.getItem('popupFechado') === 'true') {
      popup.classList.add('fechado');
    }
    
  }

  /**
   * Lista os contratos
   */
  buscaContratos(): void {
    this.copiaContratoService.listarContrato().subscribe(
      (result: EnderecoContrato) => {
        if (result.cdMsgemRetorno === '0') {
          this.contratoList = result.listaCopiaContrato;
        } else if (result.cdMsgemRetorno === '1007') {
          this.sair();
        } else {
          this.mensagemErro = result.dsMsgemRetorno;
        }
      },
      () => this.mensagemService.servicoIndisponivel(this.getMensagem('ERRO_CHAMADA_SERVICO')),
      () => this.spinnerService.hide()
    );
  }

  /**
   * Exibe os dados do contrato
   * @param copiaContrato
   */
  showDisponivel(copiaContrato: CopiaContrato): void {
    this.copiaContratoService.recuperarContrato(copiaContrato.nuContrato, 0).subscribe(
      (result: CopiaContrato) => {
        if (+result.cdMsgemRetorno === 105) {
          this.dialog.open(CopiaContratoModalDisponivelComponent, {
            width: Config.POPUP_100VW,
            data: {
              copiaContrato: result
            }
          });
        }else {
          this.dialog.open(BraAlertComponent, {
            width: Config.POPUP_50VW,
            data: {
              mensagem: result.dsMsgemRetorno
            }
          });
        }
      },
      (error: Response) => {
        if (error.toString().startsWith('TimeoutError', 0)) {
          this.spinnerService.hide();
          this.dialog.open(BraAlertComponent, {
            width: Config.POPUP_50VW,
            data: {
              mensagem: this.msgTimeOut
            }
          });
        } else {
          this.mensagemService.servicoIndisponivel(this.getMensagem('ERRO_CHAMADA_SERVICO'));
        }
      },
      () => this.spinnerService.hide()
    );

  }

  /**
   * Exibe os dados do contrato
   * @param copiaContratoOrquestradora
   */
  showDisponivelOrquestrador(copiaContrato: CopiaContrato): void {
    const ano = copiaContrato.dtBaseContrato.substring(0,4);
    const mes = copiaContrato.dtBaseContrato.substring(4,6);
    const dia = copiaContrato.dtBaseContrato.substring(6);
    const dataBaseFormatada = dia + "-" + mes + "-" + ano;
    
    this.copiaContratoService.recuperarContratoNew(copiaContrato.nuContrato.toString(), dataBaseFormatada).subscribe(
      (result: CopiaContratoNewSpaceOrquestradora) => {         
        if(result.status === "001" && result.origem == "NEWSPACE") {
          this.dialog.open(CopiaContratoModalDisponivelComponent, {
            width: Config.POPUP_100VW,
            data: {
              copiaContratoNew: result
            }
          });
        }
        else if(result.status === "002" || result.status === "003") {
          this.dialog.open(CopiaContratoModalIndisponivelComponent);
        }
        else if(result.status === "004" || 
          result.status === "005" ||
          result.status === "006" || 
          result.status === "007" || 
          result.status === "008" || 
          result.status === "009") {

            this.dialog.open(CopiaContratoModalAvisoCentralComponent);
        }
        else if(result.origem == null){
          this.dialog.open(CopiaContratoModalAvisoCentralComponent);
        }
        else if(result.origem == "NEWSPACE"){
          this.dialog.open(CopiaContratoModalAvisoCentralComponent);
        }
        else if(result.origem == "ESIGN" && result.conteudoBase64 == null){
          this.dialog.open(CopiaContratoModalAvisoCentralComponent);
        }
        else if(result.conteudoBase64 != null && result.conteudoBase64 != "") {
          this.dialog.open(CopiaContratoModalDisponivelComponent, {
            width: Config.POPUP_100VW,
            data: {
              copiaContratoNew: result
            }
          });
        }
      },
      (error: Response) => {

        if(error.status == 500) {
           this.spinnerService.hide();
          this.dialog.open(CopiaContratoModalSistemaIndisponivelComponent);
        }
        else if(error.status == 404) {
           this.spinnerService.hide();
          this.dialog.open(CopiaContratoModalAvisoCentralComponent);
        }
        else if(error.status == 408) {
          this.spinnerService.hide();
          this.dialog.open(CopiaContratoModalAvisoCentralComponent);
        }
        
      },
      () => this.spinnerService.hide()
    );

  }

  sumirPopUp() {

    const popup = document.getElementById('popUp');
    popup.classList.add('fechado');
    sessionStorage.setItem('popupFechado', 'true');
   

  }


  

  /**
   * Efetua o logout do sistema e redireciona para o autoline
   */
  sair() {
    sessionStorage.removeItem("sessao");
    sessionStorage.clear();
    this.sessaoService.sessao.logado = false;
    this.router.navigate(['/redirecionamento']);
  }
}




// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/bf-copia-contrato-cli/copia-contrato-selecao.component.ts